import { KEY_MAPPING_BUTTON, KEY_MAPPING_DEFAULT_BUTTON, KEYBORARD_KEY, CLEAR_REDUX } from "../actionTypes";

let keyMapping = {
  Menu: "",
  "Toggle Speakers": "",
  "Toggle Headlights": "",
  "Toggle Microphone": "",
  "Scan Checkpoint": "",
  "Accelerate/Reverse": {
    key: "",
    "Inverted Axis": false
  },
  "Accelerate Input": {
    key: "",
    "Inverted Axis": false,
    "Centered Axis": false,
    AxisEasing: 0,
    DeadzoneRest: 1,
    DeadzoneEnd: 1,
  },
  "Reverse Input": {
    key: "",
    "Inverted Axis": false,
    "Centered Axis": false,
    AxisEasing: 0,
    DeadzoneRest: 1,
    DeadzoneEnd: 1,
  },
  "Steer Left/Right": {
    key: "",
    "Inverted Axis": false,
    "Centered Axis": false,
    AxisEasing: 0,
    DeadzoneRest: 1,
    DeadzoneEnd: 1,
  },
  "Drive Forwards": "",
  "Drive Backwards": "",
  "Drive Left": "",
  "Drive Right": "",
  "Shift Up Speed": "",
  "Shift Down Speed": "",
  "Shift Up AngularBias": "",
  "Shift Down AngularBias": "",
};

const keyBoardkeyMapping = {
  Menu: 'm',
  'Toggle Speakers': 'z',
  'Toggle Headlights': 'x',
  'Toggle Microphone': 'c',
  'Scan Checkpoint': 'r',
  'Drive Forwards': 'w',
  'Drive Backwards': 's',
  'Drive Left': 'a',
  'Drive Right': 'd',
  'Shift Up Speed': 'e',
  'Shift Down Speed': 'q'
};

const initialState = {
  keyMapping: keyMapping,
  keyMappingDefaultKey: keyMapping,
  keyBoardKey: keyBoardkeyMapping
};

export const keyBindingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case KEY_MAPPING_BUTTON:
      return {
        ...state,
        keyMapping: action.payload,
      };
    case KEY_MAPPING_DEFAULT_BUTTON:
      return {
        ...state,
        keyMappingDefaultKey: action.payload,
      };
    case KEYBORARD_KEY:
      return {
        ...state,
        keyBoardKey: action.payload,
      };
    case CLEAR_REDUX:
      return initialState;
    default:
      return state;
  }
};